























import { log } from '@/log'
import {
  isSpColumnCount,
  SP_COLUMN_FOUR,
  SP_COLUMN_THREE,
  SP_COLUMN_TWO,
  SpColumnCount,
} from '@hl-itemlist/model/sp-column-count'
import Vue, { PropType } from 'vue'

interface ColumnCountOption {
  readonly count: SpColumnCount
  readonly label: string
}

/**
 * スマホ表示時の一覧の列数を選択するプルダウン(並び順セレクトと同じ見せ方)。
 * PCは常に4列で切替の対象外のため、PC幅ではコンポーネントごと非表示にする。
 */
const options: ColumnCountOption[] = [
  { count: SP_COLUMN_TWO, label: '2列表示' },
  { count: SP_COLUMN_THREE, label: '3列表示' },
  { count: SP_COLUMN_FOUR, label: '4列表示' },
]

export default Vue.extend({
  props: {
    value: {
      type: Number as PropType<SpColumnCount>,
      required: true,
    },
  },
  data() {
    return {
      options,
    }
  },
  methods: {
    onChange(value: string): void {
      // selectのvalueは文字列になるため、数値へ戻して列数として妥当なものだけを親へ返す
      const count = Number(value)
      if (isSpColumnCount(count)) {
        this.$emit('input', count)
      } else {
        // 選択肢はoptionsに限られるためここには来ないはず。来たら内部実装のミス(option定義の誤り等)
        log.warn(`hl-itemlist: unknown sp column count: ${value}`)
      }
    },
  },
})
